<template>
  <div class="broker-details">
    <MoreTitle class="mb-10px" :title="brokerName" />
    <div class="section-item broker-header">
      <!-- <div class="broker-name">{{ brokerName }}</div> -->
      <div class="update-time">{{ $t('更新时间') }}：{{ newDate }}({{ $t('每T+1结算') }})</div>
    </div>
    <MoreTitle title="持股比例与收盘价走势" />
    <div class="section-item section-margin">
      <VueEcharts :option="option" />
    </div>
    <MoreTitle title="详细数据" />
    <RkTable :data="detailList" :show-footer="false">
      <RkTableColumn prop="date" label="持股日期" align="left" fixed :width="`${postcssPatch(100)}`">
        <template slot-scope="{ row }">{{ $digitjs(row.date).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="ratio" label="持股比例" :width="`${postcssPatch(100)}`">
        <template slot-scope="{ row }">{{ $digitjs(row.ratio).unit('%').rounded() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="shareholdings" label="持股量" :width="`${postcssPatch(100)}`">
        <template slot-scope="{ row }">{{ $digitjs(row.shareholdings).convert() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="ratioIncrease" label="比例变化" :width="`${postcssPatch(100)}`">
        <template slot-scope="{ row }">{{ $digitjs(row.ratioIncrease).prefix().unit('%').rounded() }}</template>
      </RkTableColumn>

      <RkTableColumn prop="sharesIncrease" label="持股变动" :width="`${postcssPatch(100)}`">
        <template slot-scope="{ row }">{{ $digitjs(row.sharesIncrease).convert() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { VueEcharts },
  inject: ['theme'],
  data() {
    return {
      brokerDetails: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    brokerId() {
      return this.$route.query.id
    },
    brokerName() {
      return this.brokerDetails.brokerName
    },
    detailList() {
      return this.brokerDetails.items ?? []
    },
    newDate() {
      return this.detailList[0]?.date
    },
    maxmin() {
      const ratioList = this.detailList.map((item) => item.ratio)
      const closeList = this.detailList.map((item) => item.close)
      const maxRatio = Math.max(...ratioList)
      const minRatio = Math.min(...ratioList)
      const maxClose = Math.max(...closeList)
      const minClose = Math.min(...closeList)
      return { maxRatio, minRatio, maxClose, minClose }
    },
    option() {
      return {
        animation: false,
        grid: [
          {
            id: 'ratio',
            left: 60,
            right: 60,
            top: 60,
            height: 150
          },
          {
            id: 'volume',
            left: 60,
            right: 60,
            top: 240,
            bottom: 10
          }
        ],
        legend: {
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: this.theme['--font-color-2']
          }
        },
        xAxis: [
          // 价格
          {
            type: 'category',
            inverse: true,
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 8,
              color: this.theme['--font-color-3'],
              formatter: (value) => {
                return this.$dayjs(value).format('MM-DD')
              }
            }
          },
          // 成交量
          {
            type: 'category',
            gridIndex: 1,
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            }
          }
        ],
        yAxis: [
          // 比例
          {
            name: this.$t('比例'),
            nameTextStyle: {
              align: 'right',
              color: this.theme['--font-color-3']
            },
            max: this.maxmin.maxRatio,
            min: this.maxmin.minRatio,
            interval: (this.maxmin.maxRatio - this.maxmin.minRatio) / 5,
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 5,
              color: this.theme['--font-color-3'],
              formatter: (value) => {
                return this.$digitjs(value).unit('%').rounded()
              }
            }
          },
          // 收盘价
          {
            name: this.$t('价格') + '(HDK)',
            nameTextStyle: {
              align: 'left',
              color: this.theme['--font-color-3']
            },
            max: this.maxmin.maxClose,
            min: this.maxmin.minClose,
            interval: (this.maxmin.maxClose - this.maxmin.minClose) / 5,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 5,
              color: this.theme['--font-color-3'],
              formatter: (value) => {
                return this.$digitjs(value).rounded(3)
              }
            },
            splitLine: {
              lineStyle: {
                color: this.theme['--border-color-3']
              }
            }
          },
          // 持股量变动
          {
            gridIndex: 1,
            splitNumber: 1,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: this.theme['--border-color-3']
              }
            },
            axisLabel: {
              margin: 5,
              color: this.theme['--font-color-3'],
              formatter: (value) => {
                if (value !== 0) {
                  console.log(
                    this.$digitjs(value),
                    this.$digitjs(value).unit('股'),
                    this.$digitjs(value).unit('股').convert(0)
                  )
                  return this.$digitjs(value).unit('股').convert(0)
                }
              }
            }
          }
        ],
        dataset: {
          source: this.detailList
        },
        series: [
          // 持股比例
          {
            name: this.$t('持股比例'),
            type: 'line',
            encode: {
              x: 'date',
              y: 'ratio'
            },
            showSymbol: false,
            lineStyle: {
              width: 1
            },
            itemStyle: {
              color: this.theme['--font-color-4']
            },
            emphasis: {
              itemStyle: {
                color: this.theme['--font-color-4']
              },
              lineStyle: {
                width: 1
              }
            }
          },
          // 收盘价
          {
            name: this.$t('收盘价'),
            type: 'line',
            yAxisIndex: 1,
            encode: {
              x: 'date',
              y: 'close'
            },
            showSymbol: false,
            lineStyle: {
              width: 1
            },
            itemStyle: {
              color: this.theme['--main-color-2']
            },
            emphasis: {
              itemStyle: {
                color: this.theme['--main-color-2']
              },
              lineStyle: {
                width: 1
              }
            }
          },
          // 持股量变动
          {
            name: this.$t('持股量变动'),
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 2,
            encode: {
              x: 'date',
              y: 'sharesIncrease'
            },
            itemStyle: {
              color: this.theme['--main-color-1']
            }
          }
        ]
      }
    }
  },
  created() {
    this.getBrokerDetails()
  },
  methods: {
    postcssPatch,
    async getBrokerDetails() {
      const res = await this.$post(this.$api.sdk.hk + '/broker/shareholding/detail', {
        brokerId: this.brokerId,
        symbol: this.symbol,
        date: this.$dayjs().format('YYYY-MM-DD'),
        number: 10
      })
      this.brokerDetails = res.body ?? {}
    }
  }
}
</script>

<style lang="scss" scoped>
.broker-details {
  .section-item {
    padding: 0 var(--edge-padding) var(--edge-padding);
    background: var(--bg-color-2);
  }
  .broker-header {
    border-bottom: 1px solid var(--border-color-1);
  }
  .update-time {
    color: var(--font-color-3);
  }
  .echarts-container {
    height: 300px;
  }
}
</style>
